module.exports = __webpack_public_path__ + "img/tarj2-1.1e8c0411.png";